export const YasguiQueryHttpMethod = {
    POST: 'POST',
    GET: 'GET'
};
